import React from 'react';
import PropTypes from 'prop-types';

import Tab from './components/Tab';

const Tabs = (props) => {
  const { items } = props;

  return (
    <ul role="tablist">
      {items.map(item => (
        <Tab
          key={item.value}
          active={props.active}
          id={item.value}
          onSelect={item.onSelect}
          name={item.value === '/' ? 'story' : item.value}
          to={item.value}
        >
          {item.label}
        </Tab>
      ))}
    </ul>
  );
};

Tabs.displayName = 'Tabs';

Tabs.propTypes = {
  active: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

Tabs.defaultProps = {
};

export default Tabs;
